import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { OptimisationComparison } from './optimisation-comparison.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class OptimisationComparisonsService {
  private api = `${environment.applicationApi}/v1`;
  
constructor(private http: HttpClient) { }

  get(): Observable<OptimisationComparison[]> {
    return this.http.get<OptimisationComparison[]>(`${this.api}/OptimisationComparisons`);
  }
}
